<template>
	<div class="fixedRelationSearch" v-show="open">
		<div class="relationSearch">
			<span class="closebtn" @click="closefun"></span>
			<div class="searchbox">
				<input type="text" placeholder="请输入企业名称" v-model="searchtext" @keydown="searchenter" class="fl" >
				<span class="basebtn fr" @click="searchcompany()">搜索</span>
			</div>
			<p v-show="searchlist.length == 0" style="color: #999;">{{tipstext}}</p>
			<table border="0" cellspacing="0" cellpadding="0" v-show="searchlist.length>0">
				<tr>
					<th>企业名称</th>
					<th>地区</th>
					<th>企业实力</th>
					<th>操作</th>
				</tr>
				<tr :key="i"  v-for="(list,i) in searchlist"> 
					<td><span>{{list.title}} </span></td>
					<td>{{list.area}}</td>
					<td>{{list.zs100000}}</td>
					<td>
						<span :class="list.ischeck?'grayfont':'basefont'" @click="addcheck(list)">{{list.ischeck?'已':''}}添加</span>
					</td>
				</tr>
			</table>
			 <el-alert
				v-show="tipstext2.length>0"
			    :title="tipstext2"
			    type="warning"
			    show-icon>
			  </el-alert>
			<div class="checkoption oh" v-show="save_list.length>0">
				<h5 class="title fl">已选企业</h5>
				<div class="fl conright">
					<span class="fl" :key="index"  v-for="(item,index) in save_list">{{item.title}} <em
							@click="delatefun(3,item.stockCode,item.title)">-</em></span> 
				</div>
			</div>
			<div class="btnbox" v-show="save_list.length>0">
				<span class="savebtn basebtn fl" @click="savefun" v-show="isEdit && add_list.length>0">确定</span>
				<!-- <span class="cancelbtn graybtn fr" @click="closefun">取消</span> -->
			</div>
		</div>
	</div>
</template>

<script>
	export default {
	  name: 'enterprise-add-search',
			data(){return{ 
				title:"单个企业搜索后添加",
				userdata:{},  
				open:false,
				searchlist:[],
				searchtext:"", 
				save_list:[],
				title_text:"", 
				tipstext:"",
				tipstext2:'', 
				isEdit:false,
				isAdd:false,
				add_list:[],
				old_code_list:[],
			}},
			props:{ 
				refreshNum:{default:1,type:Number},//数据刷新次数
				oldList:{type:Array},//已有的列表 需要排除或者暗色显示
			},
			watch:{
				refreshNum:{
					handler(nv,ov){
						this.refreshNum=nv;
						this.save_list=this.oldList; 
						this.old_code_list=this.save_list.map(list=>{
							return list.stockCode;
						});
					 this.refreshSearch(this.oldList);
					}
				}
			},
			mounted(){ 
				this.old_code_list=this.save_list.map(list=>{
					return list.stockCode;
				});
				console.log('old_code_list',this.old_code_list)
				this.userdata=this.getuseriformation();
			},
			methods:{
				closefun() { 
					this.open = false;
					this.searchlist = [];
					this.searchtext = ''; 
					this.save_list = [];
					this.title_text = ''; 
					this.tipstext = ''; 
					this.tipstext2 = ''; 
					this.isEdit=false;
					this.isAdd=false;
				}, 
				searchenter(e) {
					if (e.keyCode == 13) {
						this.searchcompany();
					}
				},
				searchcompany() { 
					this.searchtext = $.trim(this.searchtext);
					var that = this;
					this.bus.$emit('loading', true);
					var ajaxurl = this.$api.cyl.enterprise.list() + '?page=1&type=0&search=1&kw=' + this.searchtext;
					this.$axios.get(ajaxurl, {
						headers: {
							AuthToken: this.userdata.token
						}
					}).then(function(res) {
						console.log('搜索列表', res.data,that.title_text);
						if (res.data.success) {
							that.searchlist = res.data.list.slice(0, 10);
							that.searchlist.forEach(list => { 
								list.ischeck =  that.title_text.indexOf(list.title) > -1;
							})
							if(that.searchlist.length<1){
								that.tipstext = '没有找到您需要的企业，请输入正确企业名称';
							}  
						} 
						that.bus.$emit('loading', false);
					}).catch(function(error) {});
				},
				addcheck(list) { 
					this.tipstext2=""; 
					if (!list.ischeck) { 
						//企业比较主要跑这里
						this.isEdit=true;
						this.isAdd=true;
						if (this.title_text.indexOf(list.title) < 0) {
							if(this.save_list.length>4){
								this.tipstext2='最多同时对比五家企业';
								return
							}
							this.add_list.push(list.stockCode);
							//点击选择时 将值传出去 开始获取企业信息 获取时间差 暂停
							// this.$emit('getSingleEnterCode','add',list.stockCode,list.title);
							this.save_list.push({
								stockCode: list.stockCode,
								title: list.title,
								ischecked: false,
							});
							this.refreshSearch(this.save_list,list.title,'add'); 
						}  
					}
				},
				//搜索公司名字后保存结果 临时列表引用 保存时要将新增的和列表做对比 如果有新增 就需要存到后台去
				savefun() { 
					// if(this.isEdit){
					let edittype=this.isAdd ? 'add' : 'delete';
					let last_add=[];
					this.save_list.forEach(list=>{
						this.add_list.forEach(code=>{
							if(list.stockCode == code){
								last_add.push(code);
							}
						}) 
					});
					var that=this;
					this.$emit('getAddResults',last_add,'add');
					// last_add.forEach(code=>{
					// 	this.$emit('togEnterpriseComparison','add',code,function(res){
					// 		var msgtype=res.success?'success':'warning';
					// 		var msgtext= res.success? '添加成功' : res.msg;
					// 		that.$message({type: msgtype,message: msgtext});
					// 	});
					// 	this.$emit('getSingleEnterInfor',code);
					// })
					// this.$emit('getAddEnterpriselist',this.save_list,edittype)
					// } 
					this.closefun();
				},
				//小删除 临时计算列表引用  小删除  直接上传后台删除记录列表
				delatefun(type,code, title) {
					this.tipstext1 = "";this.tipstext2="";  
					this.save_list = this.save_list.filter(list => {
						return list.title != title;
					});
					//点击选择时 将值传出去 开始获取企业信息 获取时间差
					if(this.old_code_list.indexOf(code) > -1 ){
							this.$emit('deleteItem',{stockCode:code});
					}
				
					this.refreshSearch(this.save_list,title,'delete');
				},
				//刷新搜索的企业列表内容
				refreshSearch(data,title,type){ 
				
					var text1='';
					data.forEach(list=>{
						text1=text1+list.title+',';
					})
					this.title_text=text1; 
					if(title){
						this.searchlist.forEach(list => {
							if (list.title == title) {
								list.ischeck = type == 'add';
							}
						}) 
					}  
				},
				
				
				
			},
			
			
			}
</script>

<style>
</style>